import { InvitationHeaderContainer } from "@platform/features/invitation";
import { FlowLayout } from "./FlowLayout";

export type Props = {
  title: string;
};

export const OnboardingLayout = ({ title }: Props) => {
  return (
    <FlowLayout
      title={title}
      isLoading={false}
      header={<InvitationHeaderContainer />}
    />
  );
};

export default OnboardingLayout;
